// extracted by mini-css-extract-plugin
export default {"backgroundChart":"performanceMatrix_backgroundChart__yZXuP"};